import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@pg-app/core/services/auth.service';
import { environment } from '@pg-env/environment';

interface ISendTicketDto {
  email: string;
  clientId;
}

@Component({
  selector: 'np-reactivate-account',
  templateUrl: './reactivate-account.component.html',
  styleUrls: ['./reactivate-account.component.scss']
})
export class ReactivateAccountComponent implements OnInit {
  reactivateAccForm: FormGroup;
  state = 1;
  showError = false;
  submitted = false;

  sendTicketDto: ISendTicketDto = {
    email: '',
    clientId: environment.clientId
  };

  constructor(private auth: AuthService, private fb: FormBuilder, private router: Router) { }

  get emailCtrl() {
    return this.reactivateAccForm.get('email') as FormControl;
  }

  ngOnInit() {
    this.reactivateAccForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
    this.reactivateAccForm.get('email').valueChanges.subscribe(res => {
      this.showError = false;
    });
  }

  onSubmit() {
    if (this.reactivateAccForm.valid && !this.showError) {
      this.submitted = false;
      this.sendTicketDto.email = this.reactivateAccForm.value.email;
      this.auth.sendReactivateAccountTicket(this.sendTicketDto).subscribe(
        res => {
          this.state = 2;
        },
        error => {
          this.showError = true;
        }
      );
    }
  }

  returnLogin() {
    this.router.navigate(['auth/login']);
  }
}
